import { useDefaultModal } from '../defaultModal';
import Drag from './drag.vue';
import { useActionIntercept } from '~/hooks/useActionIntercept';

interface UploadDragParams {
  title?: string;
  resourceType?: number;
  onOpen: () => void;
  onFileChange: (files: FileList) => void;
}

export const useUploadDrag = ({ title, resourceType, onFileChange, onOpen }: UploadDragParams) => {
  const { $t } = useNuxtApp();
  if (useActionIntercept()) {
    return;
  }

  const cancel = () => {
    modal.destroy();
  };
  const modal = useDefaultModal({
    closable: true,
    footer: false,
    title: title || $t('shang-chuan-su-cai'),
    width: 488,
    content: (
      <Drag resourceType={resourceType} onOpen={onOpen} onChange={onFileChange} onClose={cancel} />
    ),
  });
  return modal;
};
